import { render, staticRenderFns } from "./HotelFestiveList.vue?vue&type=template&id=76b6e9e8&"
import script from "./HotelFestiveList.vue?vue&type=script&lang=js&"
export * from "./HotelFestiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports